export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/bundle.15d0b14354b9d1117970.worker.js");
}
